export default __webpack_public_path__ + "static/media/doc-icon.c2b41709.svg";